<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <transition name="fade">
        <div class="col-sm-12 list-content nopads">
                <b-card
                        v-for="item in results"
                        v-bind:key="item.id"
                        :title="item.name"
                        tag="article"
                        class="mt-2"
                >
                    <b-card-text> {{ item.description }}</b-card-text>
                    <div class="round-btn" @click.stop="$emit('edit', item)"><font-awesome-icon icon="pencil-alt"/></div>
                </b-card>
        </div>
    </transition>
</template>

<script>

    export default {
        name: 'organization-list',
        props: {
            results: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {
            }
        },
        methods: {
            getAddressString: function (address) {
                let string = address.street_address
                if (address.postal) {
                    string += ' ' + address.postal
                }
                if (address.city) {
                    string += ', ' + address.city
                }
                if (address.country) {
                    string += ', ' + address.country
                }
                return string
            }
        }
    }
</script>
